/**
 * Date-extensions locale Arabic (Saudi Arabia) [ar-sa]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-sa', {
    monthNames: ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthShortNames: ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    dayNames: ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['أحد','إثنين','ثلاثاء','أربعاء','خميس','جمعة','سبت']
});
